var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "36.684px",
    viewBox: "0 0 55 36.684",
    enableBackground: "new 0 0 55 36.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M15.834,11.867H9.96V5.994h5.874V11.867z M11.46,10.367h2.874V7.494H11.46V10.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M15.834,30.689H9.96v-5.873h5.874V30.689z M11.46,29.189h2.874v-2.873H11.46V29.189z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M15.834,21.287H9.96v-5.874h5.874V21.287z M11.46,19.787h2.874v-2.874H11.46V19.787z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.735,
    y: 8.181,
    fill: "#00A79D",
    width: 25.305,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.735,
    y: 17.6,
    fill: "#00A79D",
    width: 25.305,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.735,
    y: 27.02,
    fill: "#00A79D",
    width: 25.305,
    height: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.1431d1f0fdd7ceb588c6e61d554b42ac.svg";
export { ForwardRef as ReactComponent };